const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the users tracks growth component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('userTracksGrowth', ['Application', 'Authorization', 'UserTracks', '$translate', function (Application, Authorization, UserTracks, $translate) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-tracks-growth.html'),
      controller: function () {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;
        self.userName = Authorization.getAuthToken().user.first_name;

        var parseUserTracks = function(items) {
          self.completedTracks = 0;
          self.recentComplete;

          angular.forEach(items, function(uTrack) {
            self.completedTracks++;
            if (!self.recentComplete) {
              self.recentComplete = uTrack;
              return;
            }

            if (uTrack.completed_date > self.recentComplete.completed_date) {
              self.recentComplete = uTrack;
            }
          });

          if (self.recentComplete) {
            self.recentComplete.completed_date = moment(self.recentComplete.completed_date).format('M/DD/YY');
          }

          self.loading = false;
        };

        self.goToTrack = function(id) {
          Application.navigation.goTo('#/view/tracks/' + id);
        };

        self.initialize = function () {
          self.loading = true;
          var firstOfYear = moment().date(1).month(0);
          self.completedSince = firstOfYear.format('MMMM YYYY');
          UserTracks.find({
            fields: 'track,completed_date,updatedAt',
            'track-populate': 'name',
            'completed_date': '$gte,date-' + firstOfYear.format('MM-DD-YY'),
            user: Authorization.getAuthToken().user._id
          }, function (data) {
            parseUserTracks(data);
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting user Tracks ', error);
            Application.notifications.setError(self.translations['modules.notifications.unableToGetUserTracks']);
          });
        };

        $translate(['modules.notifications.unableToGetUserTracks']).then(function(data){
          self.translations = data;
          self.initialize();
        });
      },
      controllerAs: 'growth'
    };
  }]);




